import React, { Children } from 'react'

export interface PanelProps {
    header: string;
    children: JSX.Element | JSX.Element[];
}

export default function Panel({header, children}: PanelProps) {
    return (
        <div className="col-12">
            <div className="bg-solitude-blue border-radius-6px p-45px lg-p-30px mb-25px">
                <div className='mb-25px'>
                    <span className='alt-font fs-18 fw-700 d-block w-90 text-dark-gray border-bottom border-2 border-color-dark-gray pb-15px mb-15px xs-w-100'>{header}</span>
                </div>
                <div className="mb-25px">
                    {children}
                </div>
            </div>
        </div>
    )
  }